import React from 'react';
import { Provider } from 'react-redux';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import ReactDOM from 'react-dom';
import './index.css';
//import App from './App';
import App from './App/app';
import LoadFont from './components/LoadFont';
import { ApplicationStore } from './store';
import * as serviceWorker from './serviceWorker';
import Theme from './components/Theme';

ApplicationStore.init();
const store = ApplicationStore.store;
const persistor = persistStore(store);
const { REACT_APP_CAPTACHA_KEY = '' } = process.env;

ReactDOM.render(
	<Provider store={store}>
		<LoadFont />
		<Theme>
			<PersistGate loading={null} persistor={persistor}>
				<GoogleReCaptchaProvider reCaptchaKey={REACT_APP_CAPTACHA_KEY} useEnterprise>
					<App />
				</GoogleReCaptchaProvider>
			</PersistGate>
		</Theme>
	</Provider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
serviceWorker.unregister();
